export default __webpack_public_path__ + "static/media/green-tick.7db5e623.svg";